export default {
  computed: {
    pageTemplate() {
      let template = this.category?.template || "category-med---";
      return () => import(`@/components/category/${template}.vue`);
    }
  }
};
